import { deriveValuesFromState } from "../utils/deriveValuesFromState.js";
function initializer(initialState) {
  const values = deriveValuesFromState(initialState);
  return {
    initialState,
    schema: initialState,
    values
  };
}
export {
  initializer
};
//# sourceMappingURL=initializer.js.map
